import { Module } from 'vuex';
import { actions } from '@/store/filters-analysis/actions';
import { getters } from '@/store/filters-analysis/getters';
import { mutations } from '@/store/filters-analysis/mutations';
import { state } from '@/store/filters-analysis/state';
import { RootState } from '@/models/states/root-state.model';
import { FiltersState } from '@/models/states/filters-state.model';

const namespaced: boolean = true;

export const filters: Module<FiltersState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
